var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('CustomModal', {
    attrs: {
      "name": "transferDesignModal",
      "clickToClose": false,
      "customClass": "generic-modals v--modal new-modal transfer-design-modal transfer-design-modal--step-".concat(_vm.step),
      "width": "100%",
      "maxWidth": 500,
      "height": _vm.isMobile ? '100%' : 'auto',
      "customRef": "transferDesignModal"
    },
    on: {
      "beforeOpen": _vm.initModal,
      "closed": _vm.closeAction
    }
  }, [_c('CustomContainer', {
    staticClass: "new-modal-wrapper customs-tools",
    attrs: {
      "elementType": "section"
    }
  }, [_c('ModalHeader', {
    attrs: {
      "modalTitle": _vm.translations.transferDesignModalTitle,
      "headerImg": true,
      "includeClose": _vm.showCloseModal
    },
    on: {
      "closeEvent": _vm.closeAction
    }
  }), _c('CustomContainer', {
    attrs: {
      "customClass": "new-modal-main-views-wrapper"
    }
  }, [_vm.step === 'choose-style' && !_vm.isLoadingData ? _c('TransferDesignContent', {
    ref: "transferDesignContent",
    on: {
      "blockCtaPrimaryButton": _vm.blockCtaPrimaryButton,
      "closeAction": _vm.closeAction,
      "showToolTip": _vm.showToolTip,
      "showCtaPrimaryButton": _vm.showCtaPrimaryButton,
      "continue": _vm.goToTransferStyleStep,
      "showCloseIcon": _vm.onShowCloseIcon
    }
  }) : _vm.step === 'transfer-style' ? _c('CustomContainer', {
    attrs: {
      "customClass": "transfer-design--wrapper content modal-scroll-area",
      "elementType": "section"
    }
  }, [_c('CustomText', {
    attrs: {
      "customClass": "transfer-design--description",
      "keyTranslation": "transferDesignLoadingText"
    }
  })], 1) : _vm._e(), _c('CustomContainer', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showSpinner,
      expression: "showSpinner"
    }],
    attrs: {
      "customClass": "loader__wrapper transfer-design-modal__spinner-wrapper"
    }
  }, [_c('loading-spinner', {
    ref: "spinner",
    attrs: {
      "show-spinner-default": _vm.showSpinner,
      "displayText": "translations.transferDesignLoadingText"
    }
  })], 1)], 1), _c('CustomContainer', {
    staticClass: "new-modal-button-nav"
  }, [_c('CustomTooltip', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.tooltipEnabled,
      expression: "tooltipEnabled"
    }],
    attrs: {
      "customsClasses": "transfer-design__tooltip custom"
    }
  }, [_c('CustomContainer', {
    attrs: {
      "customClass": "tooltip-inner"
    }
  }, [_c('CustomContainer', {
    attrs: {
      "customClass": "transfer-design__tooltip-error-icon"
    }
  }, [_vm._v("!")]), _c('CustomText', {
    attrs: {
      "keyTranslation": "transferDesignErrorTooltip"
    }
  })], 1), _c('CustomContainer', {
    attrs: {
      "customClass": "tooltip-arrow"
    }
  })], 1), _c('CustomButton', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showCta,
      expression: "showCta"
    }],
    attrs: {
      "customClass": ['new-modal-button-nav-container-cta expanded primary', {
        'disabled': _vm.disabledCta
      }],
      "type": "button",
      "keyTranslation": "transferDesignModalCta"
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.transferDesignContent.onContinue();
      }
    }
  }, [_c('template', {
    slot: "right-icon"
  }, [_c('CustomImage', {
    staticClass: "new-modal-button-nav-container-cta-icon",
    attrs: {
      "src": "".concat(_vm.assetsPath, "/svg/customizer/icon-next.svg"),
      "alt": ""
    }
  })], 1)], 2)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }